export const tourAnalytics = {
  track(event: string, properties: Record<string, any> = {}): void {
    // Replace with your analytics implementation
    if (typeof window !== 'undefined' && (window as any).analytics) {
      ;(window as any).analytics.track(event, {
        category: 'tour',
        timestamp: new Date().toISOString(),
        ...properties,
      })
    }

    // Also log to console in development or staging
    if (process.env.NODE_ENV !== 'production') {
      console.log('[Tour Analytics]', event, properties)
    }
  },

  trackTourStarted(tourId: string): void {
    this.track('tour_started', {
      tourId,
      referrer: typeof document !== 'undefined' ? document.referrer : '',
      pathname: typeof window !== 'undefined' ? window.location.pathname : '',
    })
  },

  trackTourCompleted(tourId: string, durationMs: number): void {
    this.track('tour_completed', {
      tourId,
      duration: durationMs,
      durationSeconds: Math.round(durationMs / 1000),
    })
  },

  trackTourDismissed(tourId: string, step: number, totalSteps: number): void {
    this.track('tour_dismissed', {
      tourId,
      step,
      totalSteps,
      completionRate: Math.round((step / totalSteps) * 100),
    })
  },

  trackTourStep(
    tourId: string,
    step: number,
    action: 'next' | 'previous',
  ): void {
    this.track('tour_step', {
      tourId,
      step,
      action,
    })
  },

  trackTourError(tourId: string, error: string): void {
    this.track('tour_error', {
      tourId,
      error,
    })
  },
}
